import React from 'react'
import Bookings from '../../components/Booking/Bookings'
import Layout from '../../components/Layout/Layout'

const Booking = () => {
  return (
    <div>
      <Layout>
        <Bookings/>
        </Layout>
    </div>
  )
}

export default Booking